import React from 'react'
import Form from './SettingsForm'

const SettingsForm = (props) => (
  <Form {...props} />
)

export default SettingsForm



// WEBPACK FOOTER //
// ./src/components/SettingsForm/index.js